export default "__VITE_ASSET__CMCWwO2O__"